import { useEffect, useState } from 'react';
import YouTube from 'react-youtube';

import { useTheme } from '../../context/ThemeContext';

interface Props {
	videoId: string;
	id: number;
	loop?: boolean;
	onEnd?: () => void;
}

export function CardYouTube({ videoId, loop, onEnd, id }: Props) {
	const [isPlaying, setIsPlaying] = useState(false);
	const { settings } = useTheme();

	const rotation = settings.rotation ?? 0;

	useEffect(() => {
		const time = setTimeout(() => {
			if (false === isPlaying && onEnd) {
				onEnd();
			}
		}, 10000);

		return () => clearTimeout(time);
	}, [isPlaying]);

	const wrapperClass = {
		0: `
			top-[calc(50%-50vw)]
			left-[calc(50%-50vh)]
			w-[100vh]
			h-[100vw]
			rotate-[270deg]
			origin-center
		`,
		90: `
			top-[calc(50%-50vh)]
			left-[calc(50%-50vw)]
			w-[100vw]
			h-[100vh]
			rotate-[270deg]
			origin-center
		`,
		180: `
			top-[calc(50%-50vw)]
			left-[calc(50%-50vh)]
			w-[100vh]
			h-[100vw]
			rotate-[270deg]
			origin-center
		`,

		270: `
			top-[calc(50%-50vh)]
			left-[calc(50%-50vw)]
			w-[100vw]
			h-[100vh]
			rotate-[270deg]
			origin-center
		`,
	}[rotation];

	return (
		<YouTube
			videoId={videoId}
			className="relative h-full w-full"
			iframeClassName={`absolute left-0 top-0 overflow-hidden ${wrapperClass}`}
			loading="lazy"
			title="Vídeo painel Minha Oferta"
			id={`${id}-${videoId}`}
			onEnd={onEnd}
			onError={onEnd}
			onPlay={() => setIsPlaying(true)}
			opts={{
				playerVars: {
					autoplay: 1,
					loop: loop ? 1 : 0,
					disablekb: 1,
					controls: 0,
					playlist: videoId,
					rel: 0,
				},
			}}
		/>
	);
}
